import { COLORS } from 'assets/styled';
import styled, { css } from 'styled-components';

interface StyledProps {
  withoutLine: boolean;
  opacityIndex: number;
  opacityCoefficient: number;
}

export const Container = styled.div`
  background-color: ${COLORS.WHITE};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  ${(props: StyledProps) =>
    !props.withoutLine &&
    css`
      border-bottom: 1rem solid ${COLORS.BORDER};
    `}
  ${(props: StyledProps) =>
    props.opacityIndex !== undefined &&
    css`
      background-color: ${COLORS.WHITE};
      opacity: ${1 - (props.opacityIndex * props.opacityCoefficient + 0.2)};
    `}
`;

export const CategoryNameAndChevronWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 84rem;
  cursor: pointer;
  user-select: none;
`;

export const RowGap = styled.div`
  display: flex;
  gap: 10rem;
  align-items: center;
`;
